import { render } from "./IfrbProduct.vue?vue&type=template&id=c085dff4"
import script from "./IfrbProduct.vue?vue&type=script&lang=js"
export * from "./IfrbProduct.vue?vue&type=script&lang=js"
script.render = render

export default script